import BaseRepository from './base.repository';

class FoodGuideRepository extends BaseRepository {
  constructor() {
    super('/food-guide');
  }

  getPublished(params) {
    return this.client.get('', params);
  }

  getOne(mainUnique) {
    return this.client.get(`/${mainUnique}`);
  }
}

export default new FoodGuideRepository();
